module.exports = __webpack_public_path__ + "img/x_mimum.73e75df8.svg";